import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';
import { assessorXRefActions } from './assessorXRef.action';
import { assessorMergeAndFinalizeActions } from './assessorMergeAndFinalize.action';
import { assessorFireTaxXRefActions } from './assessorFireTaxXRef.action';

const { backend } = clients.direct;
const assesorTaxTotalFields = {
  totalRecords: '',
  totalTaxAmount: '',
  totalRecordsWithError: '',
  // Tulsa: the Assessor file names its subdivisions, so the conversion maintains the shared
  // additions list itself. This is what it created and changed on the county's behalf.
  additionSync: {
    ranAt: '',
    namedCodeCount: '',
    createdCount: '',
    updatedCount: '',
    unchangedCount: '',
    conflictCount: '',
    listsTruncated: '',
    created: { code: '', description: '' },
    updated: { code: '', from: '', to: '' },
    conflicts: { code: '', kept: '', names: '' },
  },
};
const assesorTaxFields = {
  _id: '',
  taxYear: '',
  taxId: '',
  propertyOrParcelId: '',
  taxType: '',
  assessorTaxDistrictCode: '',
  lots: '',
  lot: '',
  legalDesc: '',
  land: '',
  improvements: '',
  mobileHome: '',
  assessorPenalty: '',
  exemptions: '',
  totalTax: '',
  acres: '',
  city: '',
  state: '',
  zip: '',
  country: '',
  ownerId: '',
  situsSuffix: '',
  situsStreetNumber: '',
  situsStreetDirection: '',
  situsStreet: '',
  situsStreetType: '',
  situsTown: '',
  situsAddress: '',
  deedBk: '',
  deedPg: '',
  // exemptionCodes: '',
  statusCode: '',
  block: '',
  section: '',
  townShip: '',
  // millCodes: '',
  ownerCity: '',
  OwnerState: '',
  range: '',
  addition: '',
  mhRealTid: '',
  grossAssessedValue: '',
  netAssessedValue: '',
  qSec: '',
  totalLevyMills: '',
  prePaidMHValue: '',
  prePaidMHTaxAmount: '',
  message: '',
  treasurerTaxDistrictCode: '',
  treasurerTaxAmt: '',
  treasurerLevies: '',
  name1: '',
  name2: '',
  inCareOf1: '',
  inCareOf2: '',
  address1: '',
  address2: '',
  address3: '',
  address4: '',
};

export const newTaxroll = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],
    assesorTotalData: {},

  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    setAssesorTotal(state, val) {
      state.assesorTotalData = val;
    },

  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },

  },
  actions: {
    ...assessorXRefActions,
    ...assessorMergeAndFinalizeActions,
    ...assessorFireTaxXRefActions,
    async loadAssesorTax({ commit, dispatch }, { criteria, baseCrudKey, postProcessTrans }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query assesorTax($criteria: assessorTaxCriteriaType) {
              assesorTax(criteria: $criteria) {
                ${fieldsToGqlString(assesorTaxFields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);

        if (baseCrudKey && results.data && results.data.assesorTax) {
          const data = postProcessTrans
            ? postProcessTrans(results.data.assesorTax)
            || [] : results.data.assesorTax;
          commit('base/crud/setItems', [baseCrudKey, data], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Tax Protest transactions!.', { root: true });
      }
    },
    async loadAssesorTaxTotal({ commit, dispatch }, { baseCrudKey, postProcessTrans }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            assesorTaxTotal {
              ${fieldsToGqlString(assesorTaxTotalFields)}
              }
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data && results.data.assesorTaxTotal) {
          const data = postProcessTrans
            ? postProcessTrans(results.data.assesorTaxTotal)
            || [] : results.data.assesorTaxTotal;
          commit('setAssesorTotal', results.data.assesorTaxTotal);
          commit('base/crud/setItems', [baseCrudKey, data], { root: true });
          return results.data.assesorTaxTotal;
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting assesor tax total !.', { root: true });
      }
      return {};
    },
    async accessorRollTheComments({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            accessorRollTheComments { statusCode },
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          return results.data.accessorRollTheComments;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting accessor roll the comments.', { root: true });
      }
      return {};
    },
    async accessorRollTheMtgCode({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            accessorRollTheMtgCode { statusCode },
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          return results.data.accessorRollTheMtgCode;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting accessor roll the mtg code.', { root: true });
      }
      return {};
    },
    async accessorRollTheStatusCode({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            accessorRollTheStatusCode { statusCode },
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          return results.data.accessorRollTheStatusCode;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting accessor roll the status code.', { root: true });
      }
      return {};
    },
  },
};

export default newTaxroll;
